import MuiDrawer from '@mui/material/Drawer';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import { CSSObject, styled, Theme } from '@mui/material/styles';

// Utilities
import { DRAWER_WIDTH, DRAWER_WIDTH_CLOSE } from 'src/utils/constants/config';

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: DRAWER_WIDTH_CLOSE,
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const List = styled(MuiList)(() => ({
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
}));

export const ListItem = styled(MuiListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  width: 'auto',
  ' &:hover': {
    // backgroundColor: 'rgba(66, 42, 251, 0.1)',
    color: theme.palette.primary.main,
  },
  cursor: 'pointer',
}));

export const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: 'rgba(66, 42, 251, 0.1)',
    color: theme.palette.primary.main,
    '& .MuiTypography-subtitle2': {
      color: theme.palette.primary.main,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root path': {
      fill: theme.palette.primary.main,
    },
  },

  '&:focus': {
    backgroundColor: theme.palette.common.white,
  },

  justifyContent: 'center',
  '&.Mui-disabled': {
    ' &:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    '& .MuiListItemIcon-root': {
      color: theme.palette.common.white,
    },
    '& .MuiTypography-root': {
      color: theme.palette.common.white,
    },
    '& .MuiSvgIcon-root path': {
      fill: theme.palette.common.white,
    },
  },
}));

export const ListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  justifyContent: 'center',
  minWidth: 0,
  width: 16,
  color: theme.palette.text.secondary,
}));
